class TootoAboutValues extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.dataset.animationEnabled !== 'true' || reducedMotion || !('IntersectionObserver' in window)) {
      this.classList.add('is-visible');
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.classList.add('is-visible');
        this.observer.disconnect();
      },
      { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('tooto-about-values')) {
  customElements.define('tooto-about-values', TootoAboutValues);
}
